module.exports = __webpack_public_path__ + "static/img/5.62b3da0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/5.png
// module id = Dnt/
// module chunks = 0